import React from 'react'
import { Box } from '@maui/elements'
import { useSelector } from 'react-redux'

import { selectNotifications } from '../../store/notifications'
import Notification from './Notification'

function Notifications() {
  const notifications = useSelector(selectNotifications)

  return (
    <Box
      position='fixed'
      top={0}
      right={0}
      zIndex='1000001'
    >
      {notifications.map(({ id }) =>
        <Notification key={id} id={id} />
      )}
    </Box>
  )
}

export default Notifications
